/// <amd-module name="Pipeline/Analytics/PipelineOutcome/FailedRunsCard/Actions/PipelineOutcomeFailedRunsActionsCreator" />
import { IReportContext } from "Analytics/Shared/Common/Types";
import { IPipelineOutcomeReportConfiguration } from "Pipeline/Analytics/Common/Types";
import { PipelineOutcomeFailedRunsActions } from "Pipeline/Analytics/PipelineOutcome/FailedRunsCard/Actions/PipelineOutcomeFailedRunsActions";
import * as Resources from "Pipeline/Analytics/PipelineOutcome/FailedRunsCard/Resources";
import { PipelineOutcomeFailedRunsSource } from "Pipeline/Analytics/PipelineOutcome/FailedRunsCard/Sources/PipelineOutcomeFailedRunsSource";
import { PipelineOutcomeFailingTaskGridActionsCreator } from "Pipeline/Analytics/PipelineOutcome/FailingTaskGrid/Actions/PipelineOutcomeFailingTaskGridActionsCreator";
import { IVssPageContext } from "VSS/Platform/Context";

export class PipelineOutcomeFailedRunsActionsCreator {
    private _pipelineOutcomeFailedRunsSource: PipelineOutcomeFailedRunsSource;

    constructor(
        private _actions: PipelineOutcomeFailedRunsActions,
        private _failingTaskGridActionsCreator: PipelineOutcomeFailingTaskGridActionsCreator,
        private _pageContext: IVssPageContext
    ) {
        this._pipelineOutcomeFailedRunsSource = new PipelineOutcomeFailedRunsSource(_pageContext);
    }

    public updateConfigurationValues(reportContext: IReportContext, newConfValues: IPipelineOutcomeReportConfiguration): Promise<void> {
        this._actions.updateConfigurationValuesAction.invoke(newConfValues);
        this._actions.selectStageAction.invoke(Resources.AllStageName);
        return this._updateData(reportContext, newConfValues);
    }

    public selectStage(stageFullName: string): void {
        this._actions.selectStageAction.invoke(stageFullName);
    }

    public async initializeStages(reportContext: IReportContext, confValues: IPipelineOutcomeReportConfiguration): Promise<void> {
        try {
            const data = await this._pipelineOutcomeFailedRunsSource.getStages(reportContext, confValues);
            this._actions.initializeStagesAction.invoke(data);
        } catch (error) {
            this._actions.onError.invoke(error);
            return Promise.reject(error);
        }
    }

    private async _updateData(reportContext: IReportContext, confValues: IPipelineOutcomeReportConfiguration): Promise<void> {
        try {
            const data = await this._pipelineOutcomeFailedRunsSource.queryTaskFailureSummaryAndTrendDataAllStage(reportContext, confValues);
            this._actions.updateDataAction.invoke(data);
            this._failingTaskGridActionsCreator.updateConfigurationValues(reportContext, confValues);
        } catch (error) {
            this._actions.onError.invoke(error);
            return Promise.reject(error);
        }
    }
}
